var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRowLabels(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 35.203 31.823",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.169,31.823H7.034c-3.878,0-7.034-3.155-7.034-7.033V7.033C0,3.155,3.155,0,7.034,0h21.136c3.878,0,7.034,3.155,7.034,7.033v17.757c0,3.878-3.155,7.033-7.034,7.033ZM7.034,2.066c-2.739,0-4.966,2.229-4.966,4.967v17.757c0,2.738,2.228,4.967,4.966,4.967h21.136c2.739,0,4.966-2.229,4.966-4.967V7.033c0-2.738-2.228-4.967-4.966-4.967H7.034Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.056,16.999H6.842c-.601,0-1.087-.486-1.087-1.087s.486-1.087,1.087-1.087h21.213c.601,0,1.087.486,1.087,1.087s-.486,1.087-1.087,1.087Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.959,24.717c-.278,0-.556-.105-.769-.318-.425-.425-.425-1.112,0-1.537l5.441-5.441c.854-.854.854-2.244,0-3.099l-5.358-5.358c-.425-.425-.425-1.112,0-1.537.424-.426,1.113-.426,1.537,0l5.358,5.358c1.702,1.702,1.702,4.471,0,6.173l-5.441,5.441c-.212.213-.49.318-.769.318Z",
    fill: "currentColor"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRowLabels);
export default __webpack_public_path__ + "static/media/RowLabels.78ffa97d.svg";
export { ForwardRef as ReactComponent };